var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',[_c('b-datepicker',{style:({'background-color':'#515b65'}),attrs:{"value":_vm.value,"date-format-options":{
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    },"label-no-date-selected":_vm.placeholder,"reset-button":"","hide-header":"","start-weekday":"1","dark":""},on:{"input":function($event){return _vm.$emit('input', $event)}}}),_c('b-input-group-append',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.$emit('input', null)}}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }